module.exports = __webpack_public_path__ + "static/img/beta_bg_white_13.3b461705.svg";